import { FC } from "react";
import { NavLink } from "react-router-dom";
// Components
import { Flex, Icon, Paper, Spacer, Title, Text } from "components";
// Types
// Assets
import styles from "./GenericSummaryCard.module.scss";
import { ICON_NAMES } from "constants/Icons";
import { Tag } from "tags/components/Tag";

export interface GenericSummaryCardProps {
  id: string;
  title: string;
  onClickUrl: string;
  icon: {
    value: keyof typeof ICON_NAMES;
    color: string;
    size?: number;
    ownership?: string;
  } | null;
  // metrics: Array<Metrics> | undefined;
  // withCevron: boolean;
  // species: number | string; // change back to number
  animalCount: number;
  male: number;
  female: number;
}

interface Metrics {
  icon: string;
  text: string;
}
export interface GenericListCard {
  id: string;
  title: string;
  icon: {
    value: string;
    color: string;
    size?: number;
    ownership?: string;
  } | null;
  metrics: Array<Metrics> | undefined;
  withCevron: boolean;
  species: number | string; // change back to number
  animalCount: number;
  male: number;
  female: number;
  alerts?: number | null;
  handleAlertsPress?: () => void;
  showChevronRight: boolean;
  handler?: () => void;
  withSwipeableIndicator?: boolean;
}

export const GenericSummaryCard: FC<{ item: GenericSummaryCardProps }> = ({ item }) => {
  const { title, onClickUrl, icon, animalCount, male, female } = item;
  return (
    <Paper shadow>
      <NavLink to={onClickUrl} className={styles.animals_summary_card}>
        <Flex
          item
          container
          data-testid={title.toLowerCase().replace(/\s/g, "")}
          className={styles["animals_summary_card_wrapper"]}
        >
          <Flex item itemGutter container containerDirection="column" xs="fill">
            <Flex item itemGutter>
              <Spacer baselineHeight={1} allowDecimal />
              <Flex item itemGutter container containerDirection="row" xs="fill">
                {icon ? (
                  <>
                    {icon.value === "tags" ? (
                      <Tag tag={{ tagId: undefined, color: icon.color, name: title, ownership: icon.ownership }} />
                    ) : (
                      <Icon
                        className={styles["animals_summary_card__title_icon"]}
                        colour={icon.color}
                        name={icon.value}
                        size="medium"
                      />
                    )}
                  </>
                ) : null}
                <Title level={3} tertiary className={styles["animals_summary_card__title"]}>
                  <>{title}</>
                </Title>
              </Flex>
              <Flex item itemGutter container containerDirection="row" containerAlignItems="center">
                <Text>{animalCount} livestock</Text>
                {male && female ? (
                  <>
                    <Icon
                      name={"animalSexMale"}
                      size="tiny"
                      colour="blue500"
                      className={styles["animals_summary_card__details__sex_icon"]}
                    />
                    <Text>{male}</Text>
                    <Icon
                      name={"animalSexFemale"}
                      size="tiny"
                      colour="red400"
                      className={styles["animals_summary_card__details__sex_icon"]}
                    />
                    <Text>{male}</Text>
                  </>
                ) : null}
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </NavLink>
    </Paper>
  );
};
